import { Stage } from 'konva/lib/Stage';
import { getWindowKonvaObject } from './konva/getWindowKonvaObject';

export const getAbsolutePositionOfShape = (
  shapeId: string,
  stageObject?: Stage
) => {
  const stage = stageObject || getWindowKonvaObject().stages[0];
  if (!stage || !shapeId) return null;

  const stageBox = stage.container().getBoundingClientRect();
  const shapeNode = stage.findOne(`#shape-${shapeId}`);
  if (!shapeNode) return null;

  const shapeBox = shapeNode.getClientRect();
  return {
    x: stageBox.left + shapeBox.x + shapeBox.width / 2,
    y: stageBox.top + shapeBox.y,
    xEnd: stageBox.left + shapeBox.x + shapeBox.width / 2,
    yEnd: stageBox.top + shapeBox.y + shapeBox.height
  };
};
